export default __webpack_public_path__ + "static/media/fastener-placement-circle.491dbaf7.webp";